import { AritoFormV2 } from '@/components/custom/erp';
import { useFormDialog } from './hooks/useFormDialog';
import { BottomBarWrapper } from './BottomBarWrapper';
import type { PhieuThuFormProps } from './types';
import { FormHeader } from './FormHeader';
import { FormTabs } from './FormTabs';

export const PhieuThuForm: React.FC<PhieuThuFormProps> = props => {
  const dialog = useFormDialog(props);

  return (
    <AritoFormV2
      title={dialog.title}
      subTitle={dialog.subTitle}
      mode={dialog.formMode}
      initialData={dialog.initialValues}
      onSubmit={dialog.submit}
      schema={dialog.schema}
      headerFields={FormHeader(dialog)}
      tabs={FormTabs(dialog)}
      onClose={dialog.onClose}
      bottomBar={
        <BottomBarWrapper
          totalAmount={dialog.totals.t_tien}
          totalAmountNT={dialog.totals.t_tien_nt}
          formMode={dialog.formMode}
        />
      }
    />
  );
};
